import { useEffect, useState } from "react";
import {
  adminDeleteSubmission,
  adminListSubmissions,
  adminMarkSubmissionRead,
} from "../../lib/api";

export default function AdminSubmissions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(null);

  async function refresh() {
    setLoading(true);
    try { setItems(await adminListSubmissions()); }
    finally { setLoading(false); }
  }
  useEffect(() => { refresh(); }, []);

  async function toggleRead(s) {
    setBusy(s.id);
    try { await adminMarkSubmissionRead(s.id, !s.read); await refresh(); }
    finally { setBusy(null); }
  }
  async function onDelete(s) {
    if (!window.confirm(`Delete this enquiry from ${s.name}?`)) return;
    setBusy(s.id);
    try { await adminDeleteSubmission(s.id); await refresh(); }
    finally { setBusy(null); }
  }

  return (
    <div data-testid="admin-submissions-page" className="space-y-6">
      <header>
        <h1 className="font-serif-display italic text-2xl md:text-3xl text-white/85">Enquiries</h1>
        <p className="mt-1 text-sm text-white/50 font-serif-display italic">{items.length} total</p>
      </header>
      {loading && <p className="text-sm text-white/45 font-serif-display italic">Loading…</p>}
      <ul className="space-y-4">
        {items.map((s) => (
          <li key={s.id} data-testid={`admin-submission-${s.id}`} className={`border rounded-md p-5 ${s.read ? "border-white/10 bg-black/10" : "border-white/25 bg-black/25"}`}>
            <div className="flex items-baseline justify-between gap-4">
              <div>
                <span className="font-serif-display italic text-white/85 text-lg">{s.name}</span>
                <span className="ml-3 text-xs font-mono-editor text-white/45">{s.email}</span>
              </div>
              <span className="text-[11px] text-white/40 font-serif-display italic">{new Date(s.created_at).toLocaleString()}</span>
            </div>
            <p className="mt-1 text-xs text-white/50 font-serif-display italic">
              Photograph: {s.photograph_id ? `${s.photograph_id}${s.photograph_title ? " · " + s.photograph_title : ""}` : "—"}
            </p>
            <p className="mt-3 whitespace-pre-wrap text-sm text-white/80 leading-relaxed font-serif-display" data-testid={`admin-submission-message-${s.id}`}>{s.message}</p>
            <div className="mt-4 flex items-center gap-4 text-[11px]">
              <button type="button" onClick={() => toggleRead(s)} disabled={busy === s.id} className="text-white/60 hover:text-white nav-link">
                Mark {s.read ? "unread" : "read"}
              </button>
              <a href={`mailto:${encodeURIComponent(s.email)}?subject=${encodeURIComponent("Re: your enquiry")}`} className="text-white/60 hover:text-white nav-link">
                Reply
              </a>
              <button type="button" onClick={() => onDelete(s)} disabled={busy === s.id} className="text-red-300/70 hover:text-red-200 nav-link">
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
      {!items.length && !loading && <p className="text-sm text-white/45 font-serif-display italic">No enquiries yet.</p>}
    </div>
  );
}
